import React, { useState } from 'react';
import { Input, Button, Space, App } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { improveTexts } from 'api/aiText';
import RevisarRedaccionDrawer from 'components/mantenciones/RevisarRedaccionDrawer';

const AI_CONTEXT = 'reporte de visita técnica en terreno';

// Bloque de texto con asistente de redacción IA reusado del módulo de
// mantención (improveTexts + RevisarRedaccionDrawer). Best-effort: si la IA
// falla, el texto queda como está.
function BloqueText({ block, onChange }) {
  const { message } = App.useApp();
  const body = block.config?.body || '';
  const [aiOpen, setAiOpen] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiItems, setAiItems] = useState([]);

  const mejorar = async () => {
    if (!body.trim()) {
      message.info('Escribí algo primero para mejorarlo');
      return;
    }
    setAiLoading(true);
    setAiOpen(true);
    try {
      const { items } = await improveTexts([{ key: block.id, text: body, context: AI_CONTEXT }]);
      setAiItems(items.map((it) => ({ ...it, label: block.title || 'Texto' })));
    } catch {
      message.error('No se pudo contactar al asistente de redacción');
      setAiOpen(false);
    } finally {
      setAiLoading(false);
    }
  };

  const onRegenerate = async (key, instruction) => {
    try {
      const { items } = await improveTexts([{ key, text: body, context: AI_CONTEXT, instruction }]);
      if (items[0]) {
        setAiItems((prev) =>
          prev.map((p) =>
            p.key === key ? { ...p, improved: items[0].improved, changed: items[0].changed } : p
          )
        );
        return true;
      }
      return false;
    } catch {
      return false;
    }
  };

  const onConfirm = (result) => {
    const finalText = result[block.id];
    if (finalText !== undefined) onChange({ config: { body: finalText } });
    setAiOpen(false);
  };

  return (
    <div>
      <Input.TextArea
        rows={4}
        value={body}
        placeholder="Escribí la observación…"
        onChange={(e) => onChange({ config: { body: e.target.value } })}
      />
      <Space style={{ marginTop: 8 }}>
        <Button size="small" icon={<RobotOutlined />} onClick={mejorar} loading={aiLoading}>
          Mejorar redacción
        </Button>
      </Space>
      <RevisarRedaccionDrawer
        open={aiOpen}
        loading={aiLoading}
        items={aiItems}
        onConfirm={onConfirm}
        onSkip={() => setAiOpen(false)}
        onRegenerate={onRegenerate}
      />
    </div>
  );
}

export default BloqueText;
